export const filterSelectedCustomerOptions = (
  selectedCustomers = null,
  allCustomers,
) => {
  if (!selectedCustomers) {
    return allCustomers;
  }
  // Extract IDs from the selectedCustomers array
  let idsToExclude = new Set(selectedCustomers.map((item) => item.id));

  const unselectedCustomers = allCustomers.filter(
    (item) => !idsToExclude.has(item.key),
  );

  return unselectedCustomers;
};

export const filterUnknownCustomers = (customersOptions) =>
  customersOptions.filter(
    (x) => x.text && !x.text.toLowerCase().includes("unknown"),
  );
